import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Card,
    CardContent,
    CardHeader,
    Grid,
    Typography,
    Button,Box
} from "@mui/material";
import theme, {
    textClasses,
    buttonClasses,
} from "../../../static/styles/theme";
import {
    getInputFieldForTableRow,GetInputFieldForTableRowComponent
} from "../../Components/TemplateInputConfiguration";
import GenericLoader from "../../Components/Generic/GenericLoader";
import { handleDynamicChange,calculateTarget } from "../../../services/formFunction";
import {
    getShipmentConnectedMasterDetail,
} from "../../../redux/actions";
import { useForm } from "react-hook-form";
import DetailDialog from "./DetailDialogBox";
import { lsGet } from '../../../utils/hooks';
import GenericSingleRangeComponent from "../../Components/Generic/GenericSingleRangeComponent";
import { truncateNumber,calculateFormulaHelper } from "../../../services/functions";
import Table2 from "../../Modules/DataEntry/Asn/Table2";
import MobileCardOrderList from "./MobileCardOrderList";

let initialSKUDropdownItems = [
    { label: "SKU ID", checked: true, name: "formData.SKU_ID", disabled: true },
    { label: "SKU Name", checked: true, name: "formData.SKU_Detail", disabled: true },
    { label: "Current Stock", checked: false, name: "currentStock" },
    { label: "Total In (Till Date)", checked: false, name: "totalInStock" },
    { label: "Total Out (Till Date)", checked: false, name: "totalOutStock" },

];

const OrderSection = ({
    template,
    errors,
    dimensions,
    items,
    setItems,
    totalQuantity,
    countTillNow,
    remainingItems,
    validationCallback,
    informationShownForSKU,
    isQuantityApplicable
}) => {
    const dispatch = useDispatch();
    const { reset } = useForm();
    const masterType = (() => {
        if (template) {
            if (template.connectedMaster && template.connectedMaster.itemMaster) {
                return "itemMaster";
            }
        }
        return null;
    })();

    const [dialogData, setDialogData] = useState({});
    // const [errors, setErrors] = useState({})

    const allUom = useSelector((state) => state.uom.allUom);
    //
    const allFields =
        template?.otherTemplate && template?.otherTemplate?.length
            ? template?.otherTemplate?.at(0)?.attributes
            : [];
    // let uomIndex = allFields.map(f => f._id).indexOf("UOM");
    // if(uomIndex >= 0){
    //     allFields[uomIndex].values = allUom.map(u => ({
    //         label: u.unitName,
    //         value: u.unitValue
    //     }))
    // }
    // else{
    //     let field = {
    //         "_id": "UOM",
    //         "type": "select",
    //         "label": "Unit Of Measurement (UOM)",
    //         "description": "unit of measurements",
    //         "placeholder": "select Unit",
    //         "values": allUom.map(u => ({
    //             label: u.unitName,
    //             value: u.unitValue
    //         })),
    //         "required": true,
    //         "forType": "all",
    //         "elementType": "Selection Type",
    //         "sortType": 2,
    //     }
    //     allFields.push(field);
    // }
    const mandatoryFieldsId = useSelector(
        (state) => state.canvas.components.itemTemplate.mandatory
    )
        .filter((f) => f.templateType == template.templateType)
        .map((f) => f._id);
    const mandatoryFields = allFields.filter(
        (f) => mandatoryFieldsId.indexOf(f._id) >= 0
    );
    const otherFields = allFields.filter(
        (f) => mandatoryFieldsId.indexOf(f._id) < 0
    );
    // //("Other Fields", otherFields);
    const autoFillOnFocus = (index) => {
        if (dimensions) {
            let oldItems = [...items];
            for (let i = 0; i < otherFields.length; i++) {
                let compId = otherFields[i]._id;
                if (
                    ["weight", "length", "breadth", "height"].indexOf(compId) >= 0 &&
                    dimensions[compId]
                ) {
                    oldItems[index][compId] = dimensions[compId];
                }
            }
            setItems(oldItems);
        }
    };

    const convertDocsBase64 = (file) => {
        if (file) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    const fileReader = new FileReader();
                    fileReader.readAsDataURL(file);
                    fileReader.onload = () => {
                        resolve(fileReader.result);
                    };
                    fileReader.onerror = (error) => {
                        reject(error);
                    };
                }, 400);
            });
        } else {
        }
    };

    const handleGenericChange = async (event, i, fieldId, option = {}) => {
        const targetField = allFields.find((f) => f._id == fieldId);
        let oldItems = [...items];
        let oldObject = { ...oldItems[i] };
        if (targetField.type == "file") {
            const file = await convertDocsBase64(event.target.files[0]);
            oldObject[fieldId] = file;
        } else if (targetField.type == "checkbox") {
            // let oldValues = oldObject[fieldId] ? oldObject[fieldId] : [];
            // if (event.checked) {
            //     oldValues.push(event.value);
            // } else {
            //     let pos = oldValues.indexOf(event.value);
            //     oldValues.splice(pos, 1);
            // }
            // oldObject[fieldId] = [...oldValues];
            oldObject[fieldId] = event?.target?.value || [];
        } else {
            oldObject[fieldId] = event.target.value;
        }

        if (targetField?.extraValue?.length) {
            const tempOptions= option && typeof option == "object" ? option : {};
            targetField.extraValue.map(dl => {
                if (typeof dl == "string") {
                    oldObject[dl] = tempOptions[dl] || ""
                }
                else if (typeof dl == "object" && dl.label) {
                    oldObject[dl.label] = tempOptions[dl.label] || ""
                }
            })
        }
        if (["select"].includes(targetField.type) && targetField.setTargetValue) {
            let setKey = ""
            if (targetField?._id == "product_ID") setKey = "itemDetail"
            if (setKey)oldObject[setKey] = null
            if (event.target.value) {
                let temp = targetField.targetParameters;
                let tempObj = { "formData.UOM": 1, "currentStock": 1, "totalOutStock": 1, "totalInStock": 1 }
                for (let ele of informationShownForSKU) {
                    if (["SKU_ID", "SKU_Detail"]?.includes(ele)) {
                        tempObj[`formData.${ele}`] = 1
                    } else {
                        tempObj[ele] = 1
                    }
                }
                for (let ele of allFields) {
                    if (!["quantity", "product_ID"].includes(ele._id)) {
                        tempObj[`formData.${ele._id}`] = 1
                    }
                }
                temp.push({ label: 'projections', value: tempObj })
                changeLoader(i, true);
                oldObject["loader"] = true;
                await handleDynamicChange(
                    oldObject,
                    { ...targetField, passToken: lsGet("passToken") },
                    { value: event.target.value || "" },
                    setKey
                );
                if (setKey && (!oldObject[setKey] || Object.keys(oldObject[setKey]).length == 0)) {
                    oldObject[setKey] = null
                }
                if (setKey) {
                    oldObject["tableHeader"] = initialSKUDropdownItems;
                }
                oldObject["loader"] = false;
            }
            else {
                calculateTarget(oldObject, targetField, {})
            }
        }
        oldItems[i] = { ...oldObject };
        setItems([...oldItems]);
    };

    const getTableHeader = (headerType) => {
        let base = ["Quantity", <Box sx={{ minWidth: "200px" }}>Item Details</Box>]
        if (masterType == "itemMaster") {
            base.push("Detail", "Ready for Sale Stock", "Current Stock");
        }
        let otherHeader = allFields
            .filter((f) => ["product_ID", "quantity","totalCount"].indexOf(f._id) < 0)
            .map((of) => {
                let label = of.label;
                if (
                    headerType == "excel" &&
                    ["select", "radio", "checkbox"].indexOf(of.type) >= 0
                ) {
                    label = `${label} (${of.values.map((o) => o.value).join(",")})`;
                }
                return label;
            });
        return [...base, ...otherHeader];
    };

    const getItemRow = (i, isMobileView = false) => {
        let item = items[i];

        let base = [
            // In card layout -> show label in front
            isMobileView ? (
                <Box key="quantity" sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Typography sx={{ fontWeight: 600, mr: 1 }}>Quantity:</Typography>
                    <GenericSingleRangeComponent
                        startRange={item.quantity || null}
                        endRange={Number(remainingItems || 0) + Number(item?.quantity || 0)}
                        getOnChange={(countValue) => handleCountChange(countValue, i)}
                        endRangeInfinity={!isQuantityApplicable ? true : false}
                        valueType={"decimal"}
                    />
                </Box>
            ) : (
                // In table layout -> just input (no label)
                <GenericSingleRangeComponent
                    key="quantity"
                    startRange={item.quantity || null}
                    endRange={Number(remainingItems || 0) + Number(item?.quantity || 0)}
                    getOnChange={(countValue) => handleCountChange(countValue, i)}
                    endRangeInfinity={!isQuantityApplicable ? true : false}
                    valueType={"decimal"}
                />
            ),
            <GetInputFieldForTableRowComponent
                component={{ ...(allFields.find((f) => f._id == "product_ID") || {}), passToken: lsGet("passToken") } || {}}
                items={items}
                setItems={setItems}
                index={i}
                handleChange={handleGenericChange}
                handleFocus={autoFillOnFocus}
                errors={errors}
                showLabelForMulti={false}
                inputProps={null}
                disabled={(item && !!item.itemDetail)}
            />
            // getInputFieldForTableRow(
            //     items,
            //     i,
            //     handleGenericChange,
            //     autoFillOnFocus,
            //     errors,
            //     false,
            //     null,
            //     item.itemDetail != null
            // ),
        ];
        if (masterType == "itemMaster") {
            if (isMobileView) {
                // Mobile -> both typographies in one row
                base.push(
                    <Box
                        key={`mobile-row-${i}`}
                        sx={{ display: "flex", justifyContent: "space-around", alignItems: "center", my: 1 }}
                    >
                        {item.loader ? (
                            <GenericLoader />
                        ) : (
                            <Typography
                                sx={{ ...textClasses.boldText, color: theme.themeOrange, cursor: "pointer" }}
                                onClick={() => handleOpenDetail(i)}
                            >
                                {item.itemDetail != null ? "View Details" : "No data yet"}
                            </Typography>
                        )}

                        {item.loader ? (
                            <GenericLoader />
                        ) : (
                            <Typography sx={{ ...textClasses.boldText, color: theme.themeOrange }}>
                                {item.itemDetail != null ? (
                                    <Button
                                        sx={{
                                            p: 0.3,
                                            cursor: "text !important",
                                            ...buttonClasses.small,
                                            color: theme.themeGreen,
                                            backgroundColor: theme.themeLightGreen,
                                            border: `1px solid ${theme.themeGreen}`,
                                            "&:hover": { backgroundColor: theme.themeLightGreen },
                                        }}
                                    >
                                        {truncateNumber(item?.itemDetail?.rfsCount) || 0} {item?.itemDetail?.formData?.UOM || ""}
                                    </Button>
                                ) : (
                                    "No data yet"
                                )}
                            </Typography>
                        )}

                        {item.loader ? (
                            <GenericLoader />
                        ) : (
                            <Typography sx={{ ...textClasses.boldText, color: theme.themeOrange }}>
                                {item.itemDetail != null ? (
                                    <Button
                                        sx={{
                                            p: 0.3,
                                            cursor: "text !important",
                                            ...buttonClasses.small,
                                            color: theme.themeGreen,
                                            backgroundColor: theme.themeLightGreen,
                                            border: `1px solid ${theme.themeGreen}`,
                                            "&:hover": { backgroundColor: theme.themeLightGreen },
                                        }}
                                    >
                                        {truncateNumber(item?.itemDetail?.currentStock) || 0}{" "}
                                        {item?.itemDetail?.formData?.UOM || ""}
                                    </Button>
                                ) : (
                                    "No data yet"
                                )}
                            </Typography>
                        )}
                    </Box>
                );
            } else {
                // Desktop -> keep your existing pushes separately
                base.push(
                    item.loader ? (
                        <GenericLoader key={`detailLoader-${i}`} />
                    ) : (
                        <Typography
                            key={`detailText-${i}`}
                            sx={{ ...textClasses.boldText, color: theme.themeOrange, cursor: "pointer" }}
                            onClick={() => handleOpenDetail(i)}
                        >
                            {item.itemDetail != null ? "View Details" : "No data yet"}
                        </Typography>
                    )
                );

                base.push(
                    item.loader
                        ?
                        <GenericLoader />
                        :
                        <Typography sx={{ ...textClasses.boldText, color: theme.themeOrange, cursor: "pointer" }}>
                            {
                                item.itemDetail != null
                                    ?
                                    <Button
                                        sx={{
                                            p: 0.3,
                                            cursor: "text !important",
                                            ...buttonClasses.small,
                                            color: theme.themeGreen,
                                            backgroundColor: theme.themeLightGreen,
                                            border: `1px solid ${theme.themeGreen}`,
                                            "&:hover": { backgroundColor: theme.themeLightGreen },
                                        }}
                                    >
                                        {truncateNumber(item?.itemDetail?.rfsCount) || 0} {item?.itemDetail?.formData?.UOM || ""}
                                    </Button>
                                    :
                                    "No data yet"
                            }
                        </Typography>
                )

                base.push(
                    item.loader ? (
                        <GenericLoader key={`stockLoader-${i}`} />
                    ) : (
                        <Typography key={`stockText-${i}`} sx={{ ...textClasses.boldText, color: theme.themeOrange }}>
                            {item.itemDetail != null ? (
                                <Button
                                    sx={{
                                        p: 0.3,
                                        cursor: "text !important",
                                        ...buttonClasses.small,
                                        color: theme.themeGreen,
                                        backgroundColor: theme.themeLightGreen,
                                        border: `1px solid ${theme.themeGreen}`,
                                        "&:hover": { backgroundColor: theme.themeLightGreen },
                                    }}
                                >
                                    {truncateNumber(item?.itemDetail?.currentStock) || 0}{" "}
                                    {item?.itemDetail?.formData?.UOM || ""}
                                </Button>
                            ) : (
                                "No data yet"
                            )}
                        </Typography>
                    )
                );
            }
        }

        const others = allFields
            .filter((f) => ["product_ID", "quantity"].indexOf(f._id) < 0)
            .map((of) => {
                let comp = { ...of };
        // debugger;
                if (
                    comp._id == "UOM" &&
                    // masterType != null &&
                    items[i][comp._id] != null &&
                    items[i][comp._id] != ""
                ) {
                    comp.disabled = true;
                } else {
                    if (item?.disabled?.length > 0 && item?.disabled?.includes(of._id)) {
                        comp.disabled = true
                    }
                    else {
                        comp.disabled = false;
                    }
                }
                return (
                    <GetInputFieldForTableRowComponent
                        component={{ ...(comp || {}), passToken: lsGet("passToken")} || {}}
                        items={items}
                        setItems={setItems}
                        index={i}
                        handleChange={handleGenericChange}
                        handleFocus={autoFillOnFocus}
                        errors={errors}
                        showLabelForMulti={false}
                        inputProps={null}
                        disabled={comp.disabled == true}
                    />
                    // getInputFieldForTableRow(
                    // items,
                    // i,
                    // handleGenericChange,
                    // autoFillOnFocus,
                    // errors,
                    // false
                    // )
                );
            });

        return [...base, ...others];
    };

    const header = getTableHeader();
    const rows = items?.map((item, i) => {
        return getItemRow(i);
    });

    // const layout = getFieldsLayoutForEntry(otherFields, register, control, autoFillOnFocus, errors);

    const handleAddRow = () => {
        // let row = {
        //     itemId: "",
        //     itemDetail: null,
        //     quantity: 1,
        //     loader: false
        // }
        // setItems([...items, row])

        let fieldsData = {};
        let fields = allFields.filter((f) => f._id != "quantity");
        for (let i = 0; i < fields.length; i++) {
            if (fields[i]?.type == "checkbox") {
                fieldsData[fields[i]._id] = [];
            } else if (fields[i]?.type == "file") {
                fieldsData[fields[i]._id] = null;
            } else {
                fieldsData[fields[i]._id] = "";
            }
        }
        let newRow = {
            quantity: isQuantityApplicable ? remainingItems:1,
            itemDetail: null,
            loader: false,
            ...fieldsData,
        };
        setItems([...items, newRow]);
        reset();
    };

    const handleRemoveRow = (i) => {
        let oldItems = [...items];
        oldItems.splice(i, 1);
        setItems(oldItems);
    };

    const handleEditRow = (i) => {
        let oldItems = [...items];
        oldItems[i] = {
            ...oldItems[i],
            itemDetail: null,
        };
        setItems(oldItems);
    };

   
    const handleCountChange = (countValue, i) => {
        let oldItems = [...items];
        let oldObject = { ...(oldItems[i] || {}) }
        if (countValue <= 0) {
            oldObject.quantity = 0
        }
        else {
            if (!isQuantityApplicable) {
                oldObject.quantity = truncateNumber(countValue, 3, true);
            } else {
                let maxCap = truncateNumber(totalQuantity - (countTillNow - Number(oldObject.quantity)), 3, true,);
                oldObject.quantity = Math.min(maxCap, countValue)
            }
        }
        let formulaFields = allFields?.find(dl => dl?._id == "quantity")?.formulaFields || []
        if (formulaFields?.length > 0) {
            calculateFormulaHelper(oldObject || {}, formulaFields, oldObject, true)
        }
        oldItems[i] = oldObject
        setItems(oldItems);
    }

    const changeLoader = (i, status) => {
        let oldItems = [...items];
        oldItems[i] = {
            ...oldItems[i],
            loader: status,
        };
        setItems(oldItems);
    };

    const handleSearchButton = (i) => {
        let id = items[i].product_ID;
        let payload = {
            template_id: masterType ? template.connectedMaster.itemMaster : "",
        };
        if (masterType) {
            payload["SKU_ID"] = id;
        }

        changeLoader(i, true);
        dispatch(
            getShipmentConnectedMasterDetail(masterType, payload, (data) => {
                if (data) {
                    let oldItems = [...items];
                    oldItems[i] = {
                        ...oldItems[i],
                        itemDetail: data,
                        loader: false,
                        UOM: data.formData.UOM,
                    };
                    setItems(oldItems);
                } else {
                    let oldItems = [...items];
                    oldItems[i] = {
                        ...oldItems[i],
                        itemDetail: null,
                        loader: false,
                    };
                    setItems(oldItems);
                }
            })
        );
    };

    const handleOpenDetail = (i) => {
        setDialogData(items[i] || {});
    };

    const handleCloseDetail = () => {
        setDialogData({});
    };

    useEffect(() => {
        if (allFields?.length && !isQuantityApplicable) {
            handleAddRow();
        }
    }, [allFields])

    return (
        <Grid
            container
            sx={{ mt: 2, width: "95%", marginLeft: "auto", marginRight: "auto" }}
        >
            <Grid item sm={12} xs={12}>
                <Card sx={{ borderRadius: "8px" }}>
                    <CardHeader
                        sx={{
                            p: 2,
                            borderRadius: "8px 8px 0px 0px",
                            backgroundColor: theme.themeGray,
                            color: "black",
                            boxShadow: "0px 1px 10px gray",
                        }}
                        title={
                            <Typography sx={{ ...textClasses.normalText }}>
                                3. Order Details
                            </Typography>
                        }
                    />
                    <CardContent>
                        <Grid container>
                            {/* ✅ Web / Tablet View (Table) */}
                            <Box
                                sx={{
                                    width: "100%",
                                    overflowX: { xs: "hidden", sm: "visible" }, // no table on mobile
                                    display: { xs: "none", sm: "block" }, // hide table on mobile
                                }}
                            >
                                <Table2
                                    header={header}
                                    rows={rows}
                                    remainingItems={remainingItems}
                                    handleAddRow={handleAddRow}
                                    handleRemoveRow={handleRemoveRow}
                                    handleEditRow={handleEditRow}
                                    isQuantityApplicable={isQuantityApplicable}
                                    sx={{
                                        minWidth: { sm: "100%" },
                                    }}
                                />
                            </Box>


                            {/* ✅ Mobile View (Stacked Cards instead of Table) */}
                            <Box
                                sx={{
                                    width: "100%",
                                    display: { xs: "flex", sm: "none" }, // show only on mobile
                                    flexDirection: "column",
                                    gap: 2,
                                }}
                            >
                                <MobileCardOrderList
                                    items={items}
                                    setItems={setItems}
                                    handleAddRow={handleAddRow}
                                    handleRemoveRow={handleRemoveRow}
                                    getItemRow={getItemRow}
                                />
                            </Box>
                        </Grid>
                        {dialogData && <DetailDialog rowDetail={dialogData} onClose={handleCloseDetail} titleKey="formData.SKU_ID" />}
                        <Typography
                            sx={{
                                ...textClasses.boldText,
                                color: theme.themeOrange,
                                mt: 2,
                                ml: 2,
                            }}
                        >
                            Total Order Quantity: {truncateNumber(Number(countTillNow || 0) || 0)}
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
};

export default OrderSection;